import { configureStore } from '@reduxjs/toolkit';
import throttle from 'lodash.throttle';
import { useDispatch } from 'react-redux';
import {
    saveClientSelection,
    setGeneratedReports,
    setIsBannerShown,
    setSwitchUser,
} from '../canopy-ui-components/helpers/localStorage';
import appDataSlice from './slices/AppDataSlice';
import authSlice from './slices/AuthSlice';
import clientsSlice from './slices/ClientsSlice';
import reportsSlice from './slices/ReportsSlice';
import themeSlice from './slices/ThemeSlice';

const store = configureStore({
    reducer: {
        appData: appDataSlice.reducer,
        clients: clientsSlice.reducer,
        auth: authSlice.reducer,
        reports: reportsSlice.reducer,
        themeConfig: themeSlice.reducer,
    },
});

store.subscribe(
    throttle(() => setSwitchUser(store.getState()?.auth?.switchUser), 100)
);
store.subscribe(
    throttle(() => saveClientSelection(store.getState()?.clients), 100)
);
store.subscribe(
    throttle(
        () => setGeneratedReports(store.getState()?.reports?.generatedReports),
        100
    )
);
store.subscribe(
    throttle(
        () => setGeneratedReports(store.getState()?.reports?.generatedReports),
        100
    )
);
store.subscribe(
    throttle(
        () => setIsBannerShown(store.getState()?.appData.isBannerShown),
        100
    )
);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
